import React, { useEffect, useMemo, useState } from 'react';
import { Platform, View, TextInput } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from '../NeedHelpDC';
import Typography from '../../typography/Typography';
import Space from '../../space/Space';
import Icon from '../../icon/Icon';
import ForeClosureReason from './ForeclosureReason';
import Button from '../../button/Button';
import ForeclosureInfo from './ForeclosureInfo';
import BottomSheetMfAnimation from '../../bottomSheetMfAnimation/BottomSheetMfAnimation';
import { BottomSheetAnimation } from '../../bottomSheetMF/bottomSheetMf';
import * as Animatable from 'react-native-animatable';
const ForeclosureReasonPage = ({ height, contactUsDetails, collateralStepperData, mutualFundStepperData, loanStepperData, prepayStepperData, goBackAction, releaseCollateralAction, navigateToDashboardAction, closeAccountAction, clearDuesAction, triggerAction, feedbackStoreAction, }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [showReleaseCollateralCard, setShowReleaseCollateralCard] = useState(false);
    const [showMututalFundCard, setShowMututalFundCard] = useState(false);
    const [showLoanCard, setShowLoanCard] = useState(false);
    const [showPrepayCard, setShowPrepayCard] = useState(false);
    const [showFeedbackCard, setShowFeedbackCard] = useState(false);
    const [showOtherFeedbackCard, setShowOtherFeedbackCard] = useState(false);
    const [showResponseCard, setShowResponseCard] = useState(false);
    const [feedbackInput, setFeedbackInput] = useState('');
    const [feedbackInputHeight, setFeedbackInputHeight] = useState(0);
    const [isFocused, setIsFocused] = useState(false);
    const [otherFeedbackInput, setOtherFeedbackInput] = useState('');
    const [otherFeedbackInputHeight, setOtherFeedbackInputHeight] = useState(0);
    const [isOtherFocused, setIsOtherFocused] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [btnLoading, seBtntLoading] = useState(false);
    const handleCloseModal = () => {
        if (btnLoading || isLoading)
            return;
        setShowReleaseCollateralCard(false);
        setShowMututalFundCard(false);
        setShowLoanCard(false);
        setShowPrepayCard(false);
        setShowFeedbackCard(false);
        setShowOtherFeedbackCard(false);
        setShowResponseCard(false);
    };
    useEffect(() => {
        handleCloseModal();
    }, []);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Select reason', needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const handleReleaseCollateral = async () => {
        if (btnLoading)
            return;
        setLoading(true);
        await triggerAction(releaseCollateralAction);
        setShowReleaseCollateralCard(false);
        setShowMututalFundCard(false);
        setLoading(false);
    };
    const handleActiveAction = async () => {
        if (btnLoading)
            return;
        await triggerAction(navigateToDashboardAction);
    };
    const handleCloseAccountAction = async () => {
        if (isLoading)
            return;
        seBtntLoading(true);
        await triggerAction(closeAccountAction);
        handleCloseModal();
        seBtntLoading(false);
    };
    const handleClearDuesAction = async () => {
        if (btnLoading)
            return;
        setLoading(true);
        await triggerAction(clearDuesAction);
        setShowPrepayCard(false);
        setLoading(false);
    };
    const ReleaseCollateralCard = () => {
        return (React.createElement(View, null,
            React.createElement(ForeclosureInfo, { title: 'You can release your collateral while keeping your account active', subTitle: 'Benefits of your account you should consider', stepperData: collateralStepperData, icon: IconTokens.COLLATERAL_ICON })));
    };
    const MutualFundCard = () => {
        return (React.createElement(View, null,
            React.createElement(ForeclosureInfo, { title: 'You can release your collateral while keeping your account active', subTitle: 'Benefits of your account you should consider', stepperData: mutualFundStepperData, icon: IconTokens.MUTUAL_FUNDS_ICON })));
    };
    const LoanCard = () => {
        return (React.createElement(View, null,
            React.createElement(ForeclosureInfo, { title: 'Our loan account acts differently compared to traditional loans', subTitle: 'Benefits of your account you should consider', stepperData: loanStepperData, icon: IconTokens.DISCARD_LOAN_ICON })));
    };
    const PrepayCard = () => {
        return (React.createElement(View, null,
            React.createElement(ForeclosureInfo, { title: 'Paying off the outstanding balance stops interest charges', subTitle: 'Benefits of clearing all your dues that you should consider', stepperData: prepayStepperData, icon: IconTokens.PREPAY_LOAN_ICON })));
    };
    const FeedbackCard = () => {
        return (React.createElement(View, { style: { flex: 1 } },
            React.createElement(Typography, { label: 'Help us improve', typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { flex: 1, marginTop: 16 } },
                React.createElement(TextInput, { style: [
                        { width: "100%", borderWidth: 1, borderColor: isFocused ? '#E4E7EC' : "#E4E7EC",
                            borderRadius: 4, paddingVertical: 12, paddingLeft: 16, paddingRight: 12, fontSize: 14, overflow: 'hidden',
                            color: feedbackInput?.length > 0 ? '#1D2939' : '#98A2B3', textAlignVertical: "top", height: 120 },
                        Platform.OS === 'web' && {
                            //@ts-ignore
                            outlineStyle: 'none',
                        },
                    ], value: feedbackInput, onChangeText: setFeedbackInput, placeholder: "What was the reason you decided to close your account?", maxLength: 500, multiline: true, onFocus: () => {
                        setIsFocused(true);
                    }, onBlur: () => setIsFocused(false) }))));
    };
    const OtherFeedbackCard = () => {
        return (React.createElement(View, { style: { width: "100%" } },
            React.createElement(Typography, { label: 'Other', typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { flex: 1, marginTop: 16 } },
                React.createElement(TextInput, { style: [
                        { width: "100%", borderWidth: 1, borderColor: isOtherFocused ? '#E4E7EC' : "#E4E7EC",
                            borderRadius: 4, paddingVertical: 12, paddingLeft: 16, paddingRight: 12, fontSize: 14,
                            color: otherFeedbackInput?.length > 0 ? '#1D2939' : '#98A2B3', textAlignVertical: "top", height: 120 },
                        Platform.OS === 'web' && {
                            //@ts-ignore
                            outlineStyle: 'none',
                        },
                    ], value: otherFeedbackInput, onChangeText: setOtherFeedbackInput, placeholder: "What was the reason you decided to close your account?", maxLength: 500, multiline: true, onFocus: () => {
                        setIsOtherFocused(true);
                    }, onBlur: () => setIsOtherFocused(false) }))));
    };
    const ResponseCard = () => {
        return (React.createElement(View, { style: { width: "100%" } },
            React.createElement(Icon, { name: IconTokens.FOLDED_HANDS_ICON, size: IconSizeTokens.XXXXXL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: 'Thank you for your response', typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(Typography, { label: 'We appreciate your input and will use it to enhance your experience with us.', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal })),
            React.createElement(Button, { label: 'Proceed to close account', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: handleCloseAccountAction })));
    };
    const renderModal = () => {
        if (showReleaseCollateralCard) {
            return ReleaseCollateralCard();
        }
        else if (showMututalFundCard) {
            return MutualFundCard();
        }
        else if (showLoanCard) {
            return LoanCard();
        }
        else if (showPrepayCard) {
            return PrepayCard();
        }
        else if (showFeedbackCard) {
            return FeedbackCard();
        }
        else if (showOtherFeedbackCard) {
            return OtherFeedbackCard();
        }
        else if (showResponseCard) {
            return ResponseCard();
        }
        else
            return React.createElement(React.Fragment, null);
    };
    const renderReleaseCollateralBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, marginTop: 24 } },
            React.createElement(View, null,
                React.createElement(Button, { label: 'Release collateral', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, onPress: handleReleaseCollateral })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Button, { label: 'I still want to close account', typeDLS: ButtonTypeDLS.TERTIARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: handleCloseAccountAction }))));
    };
    const renderMutualFundBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, marginTop: 24 } },
            React.createElement(View, null,
                React.createElement(Button, { label: 'Release collateral', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, onPress: handleReleaseCollateral })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Button, { label: 'I still want to close account', typeDLS: ButtonTypeDLS.TERTIARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: handleCloseAccountAction }))));
    };
    const renderLoanBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, marginTop: 24 } },
            React.createElement(View, null,
                React.createElement(Button, { label: 'Keep account active', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, onPress: handleActiveAction })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Button, { label: 'I still want to close account', typeDLS: ButtonTypeDLS.TERTIARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: handleCloseAccountAction }))));
    };
    const renderPrepayBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, marginTop: 24 } },
            React.createElement(View, null,
                React.createElement(Button, { label: 'Clear all dues', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, onPress: handleClearDuesAction })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Button, { label: 'I still want to close account', typeDLS: ButtonTypeDLS.TERTIARY, sizeDLS: ButtonSizeDLS.MEDIUM, loading: btnLoading, onPress: handleCloseAccountAction }))));
    };
    const renderFeedbackBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16 } },
            React.createElement(Button, { label: 'Submit', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, onPress: async () => {
                    setShowFeedbackCard(false);
                    setShowResponseCard(true);
                    await triggerAction({
                        ...feedbackStoreAction,
                        payload: {
                            remarks: feedbackInput,
                            reason: 'I had a poor experience',
                        }
                    });
                } })));
    };
    const renderOtherFeedbackBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16 } },
            React.createElement(Button, { label: 'Submit', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, onPress: async () => {
                    setShowOtherFeedbackCard(false);
                    setShowResponseCard(true);
                    await triggerAction({
                        ...feedbackStoreAction,
                        payload: {
                            remarks: otherFeedbackInput,
                            reason: 'Other',
                        }
                    });
                } })));
    };
    const renderModalBottomCard = () => {
        if (showReleaseCollateralCard) {
            return renderReleaseCollateralBottomCard();
        }
        else if (showMututalFundCard) {
            return renderMutualFundBottomCard();
        }
        else if (showLoanCard) {
            return renderLoanBottomCard();
        }
        else if (showPrepayCard) {
            return renderPrepayBottomCard();
        }
        else if (showFeedbackCard) {
            return renderFeedbackBottomCard();
        }
        else if (showOtherFeedbackCard) {
            return renderOtherFeedbackBottomCard();
        }
        else
            return React.createElement(React.Fragment, null);
    };
    const footerChild = () => {
        return (React.createElement(BottomSheetMfAnimation, { animationType: BottomSheetAnimation.NONE, bottomChild: renderModalBottomCard(), modalVisible: showReleaseCollateralCard || showResponseCard ||
                showMututalFundCard || showOtherFeedbackCard ||
                showLoanCard || showPrepayCard || showFeedbackCard, onModalClose: handleCloseModal }, renderModal()));
    };
    const openColletralCard = async () => {
        await triggerAction({
            ...feedbackStoreAction,
            payload: {
                reason: 'I want to release my collateral',
            }
        });
        setShowReleaseCollateralCard(true);
    };
    const openMututalFundCard = async () => {
        await triggerAction({
            ...feedbackStoreAction,
            payload: {
                reason: 'I want to sell my mutual funds',
            }
        });
        setShowMututalFundCard(true);
    };
    const openLoanCard = async () => {
        await triggerAction({
            ...feedbackStoreAction,
            payload: {
                reason: 'I don’t need a loan anymore',
            }
        });
        setShowLoanCard(true);
    };
    const openPrepayCard = async () => {
        await triggerAction({
            ...feedbackStoreAction,
            payload: {
                reason: 'I want to prepay my loan',
            }
        });
        setShowPrepayCard(true);
    };
    const openFeedbackCard = async () => {
        await triggerAction({
            ...feedbackStoreAction,
            payload: {
                reason: 'I had a poor experience',
            }
        });
        setShowFeedbackCard(true);
    };
    const openOtherFeedbackCard = async () => {
        await triggerAction({
            ...feedbackStoreAction,
            payload: {
                reason: 'Other',
            }
        });
        setShowOtherFeedbackCard(true);
    };
    const renderContent = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
            React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16, paddingBottom: 16 } },
                React.createElement(Typography, { label: 'Why do you want to close your loan?', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(ForeClosureReason, { title: 'I want to release my collateral', icon: IconTokens.COLLATERAL_ICON, action: openColletralCard }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(ForeClosureReason, { title: 'I want to prepay my loan', icon: IconTokens.PREPAY_LOAN_ICON, action: openPrepayCard }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(ForeClosureReason, { title: 'I want to sell my mutual funds', icon: IconTokens.MUTUAL_FUNDS_ICON, action: openMututalFundCard }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(ForeClosureReason, { title: 'I don’t need a loan anymore', icon: IconTokens.DISCARD_LOAN_ICON, action: openLoanCard }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(ForeClosureReason, { title: 'I had a poor experience', icon: IconTokens.POOR_EXPERIENCE_ICON, action: openFeedbackCard }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(ForeClosureReason, { title: 'Other', icon: IconTokens.OTHER_FEEDBACK_ICON, action: openOtherFeedbackCard }))));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.White, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })),
            footerChild()) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default ForeclosureReasonPage;
